import React, { useState, useEffect } from 'react';
import { Plus, Eye, Trash2, Paperclip, Upload, Download, Package, User } from 'lucide-react';
import { useApp } from '../App';
import { ordersService, attachmentsService } from '../services/api';

const Bosko = () => {
  const { db, setDb } = useApp();
  const [showModal, setShowModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [items, setItems] = useState([]);
  const [filterUser, setFilterUser] = useState('todos'); // Filtro por usuario creador
  
  // Escuchar cambios en configuración de colores y actualizaciones de pedidos
  useEffect(() => {
    const handleConfigChange = (event) => {
      if (event.detail.type === 'color') {
        console.log('🎨 Bosko: Colores actualizados');
      }
    };
    
    const handleOrderUpdate = async (event) => {
      console.log('🔄 Bosko: Pedido actualizado, recargando...');
      try {
        const boskoOrders = await ordersService.getOrders('bosko');
        setDb(prevDb => ({ ...prevDb, boskoOrders }));
      } catch (error) {
        console.error('Error recargando pedidos BOSKO:', error);
      }
    };

    window.addEventListener('configUpdated', handleConfigChange);
    window.addEventListener('orderUpdated', handleOrderUpdate);
    return () => {
      window.removeEventListener('configUpdated', handleConfigChange);
      window.removeEventListener('orderUpdated', handleOrderUpdate);
    };
  }, []);
  
  const [formData, setFormData] = useState({
    cliente: '',
    numeroFactura: '',
    fechaVenta: new Date().toISOString().split('T')[0],
    fechaEntrega: ''
  });

  const [currentItem, setCurrentItem] = useState({
    descripcion: '',
    color: 'Blanco',
    ancho: '',
    largo: '',
    alto: ''
  });

  const addItem = () => {
    if (!currentItem.descripcion.trim()) {
      alert('Por favor ingrese una descripción');
      return;
    }
    
    setItems([...items, { ...currentItem, id: Date.now() }]);
    setCurrentItem({
      descripcion: '',
      color: 'Blanco',
      ancho: '',
      largo: '',
      alto: ''
    });
  };

  const removeItem = (id) => {
    setItems(items.filter(item => item.id !== id));
  };

  const saveOrder = async () => {
    if (!formData.cliente.trim()) {
      alert('Por favor ingrese el nombre del cliente');
      return;
    }
    if (!formData.numeroFactura.trim()) {
      alert('Por favor ingrese el número de factura');
      return;
    }
    if (!formData.fechaEntrega) {
      alert('Por favor ingrese la fecha de entrega');
      return;
    }
    if (items.length === 0) {
      alert('Por favor agregue al menos un ítem');
      return;
    }

    try {
      const orderData = {
        client: formData.cliente,
        product: items.map(item => `${item.descripcion} (${item.color})`).join(', '),
        total: Math.floor(Math.random() * 500000) + 100000,
        date: new Date().toISOString(),
        type: 'bosko',
        numeroFactura: formData.numeroFactura,
        fechaVenta: formData.fechaVenta,
        fechaEntrega: formData.fechaEntrega,
        items: items,
        status: 'pendiente'
      };

      const savedOrder = await ordersService.createOrder(orderData);
      
      // Reload orders from backend to get the saved data
      const boskoOrders = await ordersService.getOrders('bosko');
      setDb(prevDb => ({
        ...prevDb,
        boskoOrders: boskoOrders
      }));

    } catch (error) {
      alert('Error guardando pedido: ' + error.message);
      return;
    }

    setFormData({
      cliente: '',
      numeroFactura: '',
      fechaVenta: new Date().toISOString().split('T')[0],
      fechaEntrega: ''
    });
    setItems([]);
    setShowModal(false);
    alert('Pedido BOSKO guardado exitosamente!');
  };

  const viewOrderDetails = (order) => {
    setSelectedOrder(order);
    setShowDetailsModal(true);
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'completado':
      case 'completed': return 'bg-green-100 text-green-800';
      case 'pendiente':
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'en-proceso':
      case 'in-progress': return 'bg-blue-100 text-blue-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusText = (status) => {
    switch(status) {
      case 'completado':
      case 'completed': return 'Completado';
      case 'pendiente':
      case 'pending': return 'Pendiente';
      case 'en-proceso':
      case 'in-progress': return 'En Proceso';
      default: return status;
    }
  };

  const viewOrderAttachments = async (order) => {
    setSelectedOrder(order);
    setShowAttachmentsModal(true);
    
    try {
      const orderAttachments = await attachmentsService.getOrderAttachments(order._id || order.id);
      setAttachments(orderAttachments);
    } catch (error) {
      console.error('Error cargando archivos adjuntos:', error);
      setAttachments([]);
    }
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    try {
      setUploadingFile(true);
      await attachmentsService.uploadFile(selectedOrder._id || selectedOrder.id, file);
      
      // Recargar lista de archivos
      const orderAttachments = await attachmentsService.getOrderAttachments(selectedOrder._id || selectedOrder.id);
      setAttachments(orderAttachments);
      
      alert('✅ Archivo subido exitosamente');
    } catch (error) {
      console.error('Error subiendo archivo:', error);
      alert('❌ Error al subir archivo: ' + error.message);
    } finally {
      setUploadingFile(false);
      event.target.value = ''; // Limpiar input
    }
  };

  const handleFileDownload = async (fileId, originalName) => {
    try {
      await attachmentsService.downloadFile(fileId, originalName);
    } catch (error) {
      console.error('Error descargando archivo:', error);
      alert('❌ Error al descargar archivo: ' + error.message);
    }
  };

  const handleFileDelete = async (fileId) => {
    if (!window.confirm('¿Está seguro de eliminar este archivo?')) return;
    
    try {
      await attachmentsService.deleteFile(fileId);
      
      // Recargar lista de archivos
      const orderAttachments = await attachmentsService.getOrderAttachments(selectedOrder._id || selectedOrder.id);
      setAttachments(orderAttachments);
      
      alert('✅ Archivo eliminado exitosamente');
    } catch (error) {
      console.error('Error eliminando archivo:', error);
      alert('❌ Error al eliminar archivo: ' + error.message);
    }
  };

  // Obtener lista única de usuarios creadores
  const uniqueUsers = [...new Set(db.boskoOrders.map(o => o.createdBy).filter(Boolean))];
  
  // Filtrar pedidos por usuario
  const filteredOrders = filterUser === 'todos' 
    ? db.boskoOrders 
    : db.boskoOrders.filter(o => o.createdBy === filterUser);

  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-3xl font-bold text-green-600">BOSKO - Mueble de Oficina</h2>
        <button
          onClick={() => setShowModal(true)}
          className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors"
        >
          <Plus size={20} />
          Nuevo Pedido
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-green-50 p-4 rounded-lg">
          <h3 className="text-lg font-semibold text-green-800 mb-2">Órdenes Activas</h3>
          <p className="text-3xl font-bold text-green-600">{filteredOrders.length}</p>
        </div>
        <div className="bg-blue-50 p-4 rounded-lg">
          <h3 className="text-lg font-semibold text-blue-800 mb-2">En Proceso</h3>
          <p className="text-3xl font-bold text-blue-600">{filteredOrders.filter(o => o.status === 'pending').length}</p>
        </div>
        <div className="bg-purple-50 p-4 rounded-lg">
          <h3 className="text-lg font-semibold text-purple-800 mb-2">Completadas</h3>
          <p className="text-3xl font-bold text-purple-600">{filteredOrders.filter(o => o.status === 'completed').length}</p>
        </div>
      </div>
      
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Órdenes Recientes</h3>
          
          {/* Filtro por Usuario Creador */}
          <div className="flex items-center gap-3">
            <User size={18} className="text-gray-500" />
            <label className="text-sm font-medium text-gray-700">Filtrar por Creador:</label>
            <select
              value={filterUser}
              onChange={(e) => setFilterUser(e.target.value)}
              className="px-3 py-2 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all min-w-[150px]"
              data-testid="filter-user-bosko"
            >
              <option value="todos">Todos los usuarios</option>
              {uniqueUsers.map((user, index) => (
                <option key={index} value={user}>{user}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b bg-gray-50">
                <th className="text-left p-4">ID</th>
                <th className="text-left p-4">Cliente</th>
                <th className="text-left p-4">Factura</th>
                <th className="text-left p-4">Fecha Entrega</th>
                <th className="text-left p-4">Estado</th>
                <th className="text-center p-4">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.map(order => (
                <tr key={order._id || order.id} className="border-b hover:bg-gray-50">
                  <td className="p-4 font-mono">#{(order._id || order.id).slice(0, 8)}</td>
                  <td className="p-4">{order.client || order.customer || 'N/A'}</td>
                  <td className="p-4">{order.numeroFactura || 'N/A'}</td>
                  <td className="p-4">{order.fechaEntrega ? new Date(order.fechaEntrega).toLocaleDateString('es-CO') : 'N/A'}</td>
                  <td className="p-4">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(order.status)}`}>
                      {getStatusText(order.status)}
                    </span>
                  </td>
                  <td className="p-4 text-center">
                    <div className="flex justify-center gap-2">
                      <button 
                        onClick={() => viewOrderDetails(order)}
                        className="text-blue-500 hover:text-blue-700 transition-colors p-1"
                        title="Ver detalles"
                      >
                        <Eye size={18} />
                      </button>
                      <button 
                        onClick={() => viewOrderAttachments(order)}
                        className="text-gray-500 hover:text-gray-700 transition-colors p-1"
                        title="Ver archivos adjuntos"
                      >
                        <Paperclip size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {filteredOrders.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center p-8 text-gray-500">
                    No hay pedidos registrados
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-8 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <h3 className="text-2xl font-bold mb-6">Nuevo Pedido BOSKO</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium mb-2">Cliente *</label>
                <input
                  type="text"
                  value={formData.cliente}
                  onChange={(e) => setFormData({...formData, cliente: e.target.value})}
                  className="w-full p-3 border rounded-lg"
                  placeholder="Nombre del cliente"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Nº Factura *</label>
                <input
                  type="text"
                  value={formData.numeroFactura}
                  onChange={(e) => setFormData({...formData, numeroFactura: e.target.value})}
                  className="w-full p-3 border rounded-lg"
                  placeholder="Número de factura"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Fecha de Venta *</label>
                <input
                  type="date"
                  value={formData.fechaVenta}
                  onChange={(e) => setFormData({...formData, fechaVenta: e.target.value})}
                  className="w-full p-3 border rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Fecha de Entrega *</label>
                <input
                  type="date"
                  value={formData.fechaEntrega}
                  onChange={(e) => setFormData({...formData, fechaEntrega: e.target.value})}
                  className="w-full p-3 border rounded-lg"
                />
              </div>
            </div>

            <div className="mb-6">
              <h4 className="text-lg font-semibold mb-4">Ítems del Pedido</h4>
              
              <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4 p-4 border rounded-lg bg-gray-50">
                <div>
                  <input
                    type="text"
                    value={currentItem.descripcion}
                    onChange={(e) => setCurrentItem({...currentItem, descripcion: e.target.value})}
                    className="w-full p-3 border rounded-lg"
                    placeholder="Descripción"
                  />
                </div>
                <div>
                  <select
                    value={currentItem.color}
                    onChange={(e) => setCurrentItem({...currentItem, color: e.target.value})}
                    className="w-full p-3 border rounded-lg"
                  >
                    <option value="">Seleccionar color</option>
                    {(db.colores && db.colores.length > 0 ? db.colores : ['Blanco', 'Negro', 'Madera', 'Gris']).map((color, index) => (
                      <option key={index} value={color}>{color}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <input
                    type="text"
                    value={currentItem.ancho}
                    onChange={(e) => setCurrentItem({...currentItem, ancho: e.target.value})}
                    className="w-full p-3 border rounded-lg"
                    placeholder="Ancho (cm)"
                  />
                </div>
                <div>
                  <input
                    type="text"
                    value={currentItem.largo}
                    onChange={(e) => setCurrentItem({...currentItem, largo: e.target.value})}
                    className="w-full p-3 border rounded-lg"
                    placeholder="Largo (cm)"
                  />
                </div>
                <div>
                  <input
                    type="text"
                    value={currentItem.alto}
                    onChange={(e) => setCurrentItem({...currentItem, alto: e.target.value})}
                    className="w-full p-3 border rounded-lg"
                    placeholder="Alto (cm)"
                  />
                </div>
              </div>
              
              <button
                onClick={addItem}
                className="bg-green-100 hover:bg-green-200 text-green-700 px-4 py-2 rounded-lg mb-4 transition-colors"
              >
                + Añadir Ítem
              </button>

              {items.length > 0 && (
                <div className="space-y-2">
                  {items.map(item => (
                    <div key={item.id} className="flex items-center justify-between p-3 bg-white border rounded-lg">
                      <div className="flex-1">
                        <span className="font-medium">{item.descripcion}</span>
                        <span className="text-gray-500 ml-2">({item.color})</span>
                        {(item.ancho || item.largo || item.alto) && (
                          <span className="text-sm text-gray-600 ml-2">
                            {[item.ancho, item.largo, item.alto].filter(Boolean).join(' x ')} cm
                          </span>
                        )}
                      </div>
                      <button
                        onClick={() => removeItem(item.id)}
                        className="text-red-500 hover:text-red-700 transition-colors"
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="flex gap-4">
              <button
                onClick={saveOrder}
                className="flex-1 bg-green-500 hover:bg-green-600 text-white py-3 rounded-lg font-semibold transition-colors"
              >
                Guardar Pedido
              </button>
              <button
                onClick={() => {
                  setShowModal(false);
                  setFormData({
                    cliente: '',
                    numeroFactura: '',
                    fechaVenta: new Date().toISOString().split('T')[0],
                    fechaEntrega: ''
                  });
                  setItems([]);
                }}
                className="flex-1 bg-gray-500 hover:bg-gray-600 text-white py-3 rounded-lg font-semibold transition-colors"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Detalles de Pedido */}
      {showDetailsModal && selectedOrder && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl p-8 w-full max-w-4xl max-h-[90vh] overflow-y-auto shadow-2xl">
            {/* Header con nombre del cliente y estado */}
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className="text-3xl font-bold text-gray-800 mb-2">{selectedOrder.client || selectedOrder.customer || 'Sin nombre'}</h2>
                <p className="text-gray-500 text-lg">Factura: {selectedOrder.numeroFactura || 'N/A'}</p>
              </div>
              <div className="flex items-center gap-4">
                <span className={`px-6 py-3 rounded-2xl text-lg font-semibold ${
                  selectedOrder.status === 'pendiente' 
                    ? 'bg-yellow-100 text-yellow-800 border-2 border-yellow-400' 
                    : selectedOrder.status === 'completado' || selectedOrder.status === 'entregado'
                    ? 'bg-green-100 text-green-800 border-2 border-green-400'
                    : selectedOrder.status === 'en-proceso'
                    ? 'bg-blue-100 text-blue-800 border-2 border-blue-400'
                    : selectedOrder.status === 'listo'
                    ? 'bg-purple-100 text-purple-800 border-2 border-purple-400'
                    : 'bg-gray-100 text-gray-800 border-2 border-gray-400'
                }`}>
                  {selectedOrder.status === 'pendiente' ? 'Pendiente' : 
                   selectedOrder.status === 'completado' || selectedOrder.status === 'entregado' ? 'Entregado' : 
                   selectedOrder.status === 'en-proceso' ? 'En Proceso' :
                   selectedOrder.status === 'listo' ? 'Listo para Entrega' : 'Pendiente'}
                </span>
                <button
                  onClick={() => setShowDetailsModal(false)}
                  className="text-gray-400 hover:text-gray-600 text-3xl font-bold"
                >
                  ×
                </button>
              </div>
            </div>

            {/* Fechas */}
            <div className="bg-blue-50 rounded-2xl p-6 mb-6 grid grid-cols-2 gap-8">
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <svg className="w-8 h-8 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-600 font-medium">Fecha de Venta</span>
                </div>
                <p className="text-2xl font-bold text-gray-800 ml-11">
                  {selectedOrder.fechaVenta ? new Date(selectedOrder.fechaVenta).toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' }) : 'N/A'}
                </p>
              </div>
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <svg className="w-8 h-8 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-600 font-medium">Fecha de Entrega</span>
                </div>
                <p className="text-2xl font-bold text-gray-800 ml-11">
                  {selectedOrder.fechaEntrega ? new Date(selectedOrder.fechaEntrega).toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' }) : 'N/A'}
                </p>
              </div>
            </div>

            <hr className="my-6 border-gray-200" />

            {/* Ítems del Pedido */}
            <div className="mb-6">
              <h4 className="text-2xl font-bold text-gray-800 mb-6">Ítems del Pedido:</h4>
              {selectedOrder.items && selectedOrder.items.length > 0 ? (
                <div className="space-y-4">
                  {selectedOrder.items.map((item, index) => (
                    <div key={index} className="bg-gray-50 rounded-xl p-6">
                      <div className="grid grid-cols-3 gap-6">
                        <div>
                          <p className="text-sm text-gray-500 mb-1">Descripción</p>
                          <p className="text-lg font-bold text-gray-800">{item.descripcion || 'Sin descripción'}</p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-500 mb-1">Color</p>
                          <p className="text-lg font-bold text-gray-800">{item.color || 'N/A'}</p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-500 mb-1">Dimensiones</p>
                          <p className="text-lg font-bold text-gray-800">
                            {(item.ancho || item.largo || item.alto) ? 
                              `${[item.ancho, item.largo, item.alto].filter(Boolean).join(' x ')} cm` : 
                              'N/A'
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="bg-gray-50 p-8 rounded-xl text-center text-gray-500">
                  <Package size={48} className="mx-auto mb-2 text-gray-300" />
                  <p>No hay ítems registrados para este pedido</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal de Archivos Adjuntos */}
      {showAttachmentsModal && selectedOrder && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4 max-h-[80vh] overflow-y-auto">
            <div className="p-6">
              {/* Header */}
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-800">
                  📎 Archivos Adjuntos - Pedido #{selectedOrder.numeroFactura}
                </h3>
                <button
                  onClick={() => setShowAttachmentsModal(false)}
                  className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
                >
                  ×
                </button>
              </div>

              {/* Información del Pedido */}
              <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <span className="text-sm font-medium text-gray-600">Cliente:</span>
                    <p className="font-semibold">{selectedOrder.customer}</p>
                  </div>
                  <div>
                    <span className="text-sm font-medium text-gray-600">Fecha:</span>
                    <p className="font-semibold">{new Date(selectedOrder.fechaVenta).toLocaleDateString('es-CO')}</p>
                  </div>
                </div>
              </div>

              {/* Lista de Archivos Adjuntos */}
              <div className="space-y-4">
                <h4 className="text-lg font-semibold text-gray-700 mb-4">Archivos del Pedido</h4>
                
                {/* Zona de subida de archivos */}
                <div className="border-2 border-dashed border-gray-300 p-8 text-center">
                  <Upload size={48} className="mx-auto text-gray-400 mb-4" />
                  <p className="text-gray-500 mb-4">
                    {uploadingFile ? 'Subiendo archivo...' : 'Arrastra un archivo aquí o haz clic para seleccionar'}
                  </p>
                  <input
                    type="file"
                    id="fileUpload"
                    className="hidden"
                    onChange={handleFileUpload}
                    disabled={uploadingFile}
                  />
                  <label
                    htmlFor="fileUpload"
                    className={`${
                      uploadingFile 
                        ? 'bg-gray-400 cursor-not-allowed' 
                        : 'bg-green-500 hover:bg-green-600 cursor-pointer'
                    } text-white px-4 py-2 rounded-lg transition-colors inline-block`}
                  >
                    {uploadingFile ? '⏳ Subiendo...' : '📎 Seleccionar Archivo'}
                  </label>
                </div>

                {/* Lista de archivos existentes */}
                {attachments.length > 0 ? (
                  <div className="space-y-3">
                    <h5 className="font-medium text-gray-700">Archivos adjuntos ({attachments.length})</h5>
                    {attachments.map(attachment => (
                      <div key={attachment.id} className="bg-white border rounded-lg p-4">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="bg-green-100 p-2 rounded">
                              <Paperclip size={20} className="text-green-600" />
                            </div>
                            <div>
                              <p className="font-medium">{attachment.originalName}</p>
                              <p className="text-sm text-gray-500">
                                {(attachment.fileSize / 1024 / 1024).toFixed(2)} MB • 
                                Subido {new Date(attachment.uploadedAt).toLocaleDateString('es-CO')} • 
                                Por {attachment.uploadedBy}
                              </p>
                            </div>
                          </div>
                          <div className="flex gap-2">
                            <button
                              onClick={() => handleFileDownload(attachment.id, attachment.originalName)}
                              className="text-blue-500 hover:text-blue-700 transition-colors p-1"
                              title="Descargar archivo"
                            >
                              <Download size={18} />
                            </button>
                            <button
                              onClick={() => handleFileDelete(attachment.id)}
                              className="text-red-500 hover:text-red-700 transition-colors p-1"
                              title="Eliminar archivo"
                            >
                              <Trash2 size={18} />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <p className="text-gray-500">No hay archivos adjuntos para este pedido</p>
                  </div>
                )}
              </div>

              {/* Botones de Acción */}
              <div className="mt-6 flex gap-4">
                <button
                  onClick={() => setShowAttachmentsModal(false)}
                  className="w-full bg-gray-500 hover:bg-gray-600 text-white py-3 rounded-lg font-semibold transition-colors"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Bosko;